import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'thank-you',
  templateUrl: './thankyou.component.html'
})

export class ThankyouComponent implements OnInit {
 ngOnInit(): void {
    
  }
}
